import Text from '@/components/ui/custom/dataDisplay/Text';
import moment from 'moment';
import { twMerge } from 'tailwind-merge';

type PublishDateProps = {
  publishAt: string;
  className?: string;
};

export default function PublishDate({
  publishAt,
  className,
}: PublishDateProps) {
  const publishDate = moment(publishAt);
  const formated = publishDate.format('DD MMM YYYY');
  return (
    <Text
      text={formated}
      className={twMerge('text-12 sm:text-14 text-neutral shrink-0', className)}
    />
  );
}
